import list from './list'
import addEmployees from './addEmployees'
import removeEmployees from './removeEmployees'
import addSpaces from './addSpaces'
import removeSpaces from './removeSpaces'
import create from './create'
import remove from './remove'
import details from './details'
import update from './update'
import employees from './employees'
import spaces from './spaces'
import imports from './import'
import neighborhoodList from './neighborhoodList'

export default {
  list,
  addEmployees,
  removeEmployees,
  addSpaces,
  removeSpaces,
  create,
  remove,
  details,
  update,
  employees,
  spaces,
  import: imports,
  neighborhoodList,
}
